<app-native-header [pageTitle]="getUserFullname()" (onCancel)="close()"></app-native-header>

<ion-content>
  <div class="modal-container">
    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="12" size-md="10" size-lg="8">

          <!-- User Avatar Section -->
          <div class="user-avatar-section clay-card">
            <div class="clay-card-body">
              <div class="avatar-container">
                <div class="user-avatar">
                  <span>{{getInitials()}}</span>
                </div>
                <div class="user-info">
                  <h3 class="user-name">
                    {{userProfile?.salutation?.label}} {{userProfile?.lastName}} {{userProfile?.firstName}} {{userProfile?.middleName}}
                  </h3>
                  <p class="user-status" *ngIf="!userProfile.deleted">
                    <i class="fas fa-check-circle"></i> Active Profile
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Roles & Responsibilities Card -->
          <div class="roles-card clay-card">
            <div class="clay-card-body">
              <h5 class="card-title">
                <i class="fas fa-user-tag"></i> Roles & Responsibilities
              </h5>

              <!-- Existing Responsibilities -->
              <div class="responsibilities-list" *ngIf="userProfile?.responsiblities?.length > 0">
                <div class="responsibility-item" *ngFor="let designation of userProfile.responsiblities; let respoI = index">
                  <div class="responsibility-content">
                    <div class="responsibility-details">
                      <span class="responsibility-label">{{designation?.designationLabel}}</span>
                      <div class="responsibility-meta" *ngIf="designation.department || designation.criteria">
                        <span class="meta-badge" *ngIf="designation.department">
                          <i class="fas fa-building"></i> {{designation.department.name}}
                        </span>
                        <span class="meta-badge" *ngIf="designation.criteria">
                          <i class="fas fa-layer-group"></i> Criteria {{designation.criteria}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <button
                    class="remove-btn"
                    *ngIf="!userProfile.deleted"
                    [disabled]="designation.designation =='IQAC_ADMIN' && loggedInUser.id==userProfile.id"
                    (click)="removeResponsiblity(userProfile, respoI)">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>

              <!-- Empty State -->
              <div class="empty-responsibilities" *ngIf="!userProfile?.responsiblities || userProfile?.responsiblities?.length === 0">
                <i class="fas fa-user-plus fa-2x"></i>
                <p>No roles assigned yet</p>
              </div>

              <!-- Add New Role Section -->
              <div class="add-role-section" *ngIf="metadata?.disignations?.length > 0 && !userProfile.deleted">
                <div class="section-divider">
                  <span>Add New Role</span>
                </div>

                <div class="form-grid">
                  <!-- Role Selection -->
                  <div class="form-group">
                    <label class="form-label">
                      <i class="fas fa-user-tag"></i> Select Role
                    </label>
                    <select
                      [(ngModel)]="responsiblity.designation"
                      (change)="designationChange()"
                      class="modern-select">
                      <option value="" selected disabled>Select Role</option>
                      <option *ngFor="let desg of metadata.disignations" value="{{desg.value}}">
                        {{desg.label}}
                      </option>
                    </select>
                  </div>

                  <!-- Department Selection -->
                  <div class="form-group" *ngIf="IS_DEPARTMENTMENDATORY && !isDefaultDepartment">
                    <label class="form-label">
                      <i class="fas fa-building"></i> Select Department
                    </label>
                    <select
                      [(ngModel)]="responsiblity.departmentId"
                      (change)="onDepartmentChanged()"
                      class="modern-select">
                      <option value="" selected disabled>Select Department</option>
                      <option *ngFor="let dept of departments" value="{{dept.id}}">
                        {{dept.name}}
                      </option>
                    </select>
                  </div>

                  <!-- Criteria Selection -->
                  <div class="form-group" *ngIf="IS_CRITERIA_MANDATORY">
                    <label class="form-label">
                      <i class="fas fa-layer-group"></i> Select Criteria
                    </label>
                    <select
                      [(ngModel)]="responsiblity.criteria"
                      (change)="onCriteriaChanged()"
                      class="modern-select">
                      <option value="" selected disabled>Select Criteria</option>
                      <option *ngFor="let criteria of criteriasFiltered" value="{{criteria}}">
                        Criteria {{criteria}}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- Add Role Button -->
                <div class="add-role-action">
                  <button class="action-btn add-btn" (click)="addResponsiblityInList()">
                    <i class="fas fa-plus-circle"></i> Add Role
                  </button>
                </div>
              </div>
            </div>
          </div>

        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
